<!-- 开启渠道锁客，如果用户之前进入了别的渠道，后续进入其他的渠道链接提示该弹框 -->
<template>
  <el-dialog title="" :visible.sync="dialogVisible" width="295px" :custom-class="'limit-watch-dialog'" :show-close="false" :close-on-click-modal="false">
      <p class="tips">{{  tipsText }}</p>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      tipsText: '此渠道链接不可进行观看，感谢您的参与期待下次相遇~'
    }
  },
  methods: {
    show (type) {
      // eslint-disable-next-line eqeqeq
      this.tipsText = (type == 2) ? '您未添加企微好友，暂不可观看课程。感谢您的参与期待下次相遇~' : '此渠道链接不可进行观看，感谢您的参与期待下次相遇~'
      this.dialogVisible = true
    }
  }
}
</script>

<style>
.el-dialog.limit-watch-dialog {
  width: 295px;
  height: 234px;
  margin-top: 30vh !important;
  background-color: transparent;
  background-size: 100% 100%;
  background-image: url(../assets/imgs/liveDialog/single_watch_dialog_bg.png);
}
.el-dialog.limit-watch-dialog .tips {
  font-size: 16px;
  color: #1872ed;
  margin-top: 40px;
  letter-spacing: 1px;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/userLockChannelDialog.vue